<template>
  <div class="free-wagers-wrapper">
    <div v-if="hasFreeWagers" :class="'free-wager ' + macAddress.split('.')[0]">
      <div class="p-2">
        <div class="free-wager-title text-uppercase">
          <i class="icon icon-bonuses" style="font-size: 20px;"></i>
          {{ $t('BetSlip.FreeWager.AvailableFreeWagers') }}
        </div>
        <div class="free-wager-group-wrapper mt-1">
          <free-wager-group
            v-for="(freeWager, type) in freeWagers"
            :key="freeWager.id"
            :freeWager="freeWager"
            :type="type"
            @freeWagerClick="confirmGetFreeWagerLines($event)"
          ></free-wager-group>
        </div>
      </div>
      <!-- triggered from this component -->
      <confirm-modal
        :confirm-title="$t('Accept')"
        :cancel-title="$t('Cancel')"
        @confirm="getFreeWagerLines()"
        ref="showConfirmFreeWageringViewingModal"
      >
        <h3 class="text-center">
          {{ $t('BetSlip.FreeWager.BetSlipClearInfo') }}
        </h3>
      </confirm-modal>

      <!-- triggered from sports menu or leagues etc -->
      <modal :closeable="false" v-if="showExitFreeWageringModal">
        <div class="modal-actions text-center pt-3" slot="body">
          <h3>{{ $t('BetSlip.FreeWager.BetSlipClearInfo') }}</h3>
          <button class="btn btn-danger mt-3" @click="setShowExitFreeWageringModal(false)">
            {{ $t('Cancel') }}
          </button>
          <button class="btn btn-primary mt-3 ml-3" @click="exitFreeWagering()">
            {{ $t('BetSlip.Confirm') }}
          </button>
        </div>
      </modal>

      <!-- picks added modal -->
      <modal :closeable="false" v-if="showPicksAddedModal">
        <div class="modal-actions text-center pt-3" slot="body">
          <h3>{{ $t('BetSlip.FreeWager.SelectionsAdded') }}</h3>
          <button class="btn btn-primary" @click="setShowPicksAddedModal(false)">
            {{ $t('OK') }}
          </button>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import Modal from '@/components/shared/Modal';
import FreeWagerGroup from './FreeWagerGroup';

export default {
  components: {
    Modal,
    FreeWagerGroup,
  },
  data() {
    return {
      window: window,
    };
  },
  computed: {
    ...mapState('freeWagerStore', [
      'freeWagers',
      'showExitFreeWageringModal',
      'freeWagersViewing',
      'showPicksAddedModal',
    ]),
    ...mapState('betSlip', ['selections']),
    ...mapState('settings', ['macAddress']),
    hasFreeWagers() {
      return Object.keys(this.freeWagers).length > 0;
    },
  },
  methods: {
    ...mapActions('freeWagerStore', ['tryGetFreeWagerLines']),
    ...mapActions('sportMenu', ['setActiveMenu', 'setActiveLeague']),
    ...mapMutations('freeWagerStore', [
      'setSelectedFreeWager',
      'setShowExitFreeWageringModal',
      'setFreeWagersViewing',
      'setShowPicksAddedModal',
    ]),
    ...mapMutations('betSlip', ['resetBetSlip']),
    confirmGetFreeWagerLines({ freeWager, freeWagerPrizeId }) {
      freeWager.freeWagerPrizeId = freeWagerPrizeId;
      this.setSelectedFreeWager(freeWager);
      if (this.freeWagersViewing === false) {
        if (this.selections.size > 0) {
          this.$refs.showConfirmFreeWageringViewingModal.show();
        } else {
          this.getFreeWagerLines();
        }
      } else {
        this.tryGetFreeWagerLines();
      }
    },
    getFreeWagerLines() {
      this.tryGetFreeWagerLines();
      this.resetBetSlip();
    },
    exitFreeWagering() {
      this.setFreeWagersViewing(false);
      this.resetBetSlip();
      this.setShowExitFreeWageringModal(false);

      if (window.freeWagerNavigationType === 'MENU' && window.freeWagerTempMenu) {
        this.setActiveMenu(window.freeWagerTempMenu);
      }

      if (window.freeWagerNavigationType === 'LEAGUE' && window.freeWagerTempLeagueId) {
        this.setActiveLeague(window.freeWagerTempLeagueId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins/_mixins';

.free-wagers-wrapper {
  width: 250px;
  @media (max-width: 992px) {
    width: 100%;
  }
  @media (max-width: 1024px) and (min-width: 992px) {
    width: 180px;
  }
}

.free-wager {
  background: var(--color3);

  &-title {
    color: white;
    font-weight: 700;
    i {
      top: 2px;
      position: relative;
    }

    @media (max-width: 767px) {
      font-size: 13px;
    }
  }

  &-group-wrapper {
    background-color: white;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    overflow: hidden;
    -webkit-box-shadow: 0px 0px 4px 0px rgba(148, 148, 148, 1);
    -moz-box-shadow: 0px 0px 4px 0px rgba(148, 148, 148, 1);
    box-shadow: 0px 0px 4px 0px rgba(148, 148, 148, 1);
  }
}

.free-wager.apueston {
  $secondary-button: #5bb3ff;
  background: $secondary-button;
}
</style>
